import { Environment } from './environment.model';

export type { Environment };

export const environment: Environment = {
  production: false,
  apiBaseUrl: 'https://uat-vin-portal.sgproductsapis.com/api/v1',
  sessionTtlMinutes: 15,
  features: {
    captchaEnabled: false,
    otpSimulation: false,
    mockApi: false,
    mockAdminApi: false,
    eligibilityCheckEnabled: true,
    confirmationDocumentEnabled: true,
    confirmationEmailEnabled: false,
    lithiaDealerGroup: true,
  },
  polling: {
    initialIntervalMs: 10000,
    slowIntervalMs: 30000,
    maxDurationMs: 180000,
  },
  datadog: {
    enabled: false,
    clientToken: '',
    applicationId: '',
    site: 'datadoghq.com',
    service: 'vin-portal',
    env: 'uat',
    sampleRate: 100,
    trackInteractions: true,
    trackResources: true,
  },
  salesforce: {
    instanceUrl: 'https://safe-guardproducts--l2v.sandbox.my.salesforce.com',
    supportRequestObject: 'Support_Request__c',
  },
};
